/**
 * Аналитика публичной воронки (ТРЕК 36.W4) на PostHog.
 *
 * Без `NEXT_PUBLIC_POSTHOG_KEY` всё — no-op (никаких ошибок в консоли),
 * чтобы локальная разработка и окружения без ключа работали как прежде.
 */
import posthog from "posthog-js";

const KEY = process.env.NEXT_PUBLIC_POSTHOG_KEY;
const HOST = process.env.NEXT_PUBLIC_POSTHOG_HOST || "https://us.i.posthog.com";

let started = false;

export function isAnalyticsEnabled(): boolean {
  return typeof window !== "undefined" && !!KEY;
}

export function initAnalytics(): void {
  if (started || !isAnalyticsEnabled()) return;
  posthog.init(KEY as string, {
    api_host: HOST,
    capture_pageview: false, // page_view шлём вручную из AnalyticsProvider
    capture_pageleave: true,
    autocapture: false,
    person_profiles: "identified_only",
  });
  started = true;
}

export function track(
  event: string,
  props?: Record<string, unknown>,
): void {
  if (!started || !isAnalyticsEnabled()) return;
  try {
    posthog.capture(event, props);
  } catch {
    /* never break UX on analytics failure */
  }
}

/** Канонические имена событий воронки (TC-08). */
export const EVENTS = {
  pageView: "page_view",
  ctaClick: "cta_click",
  demoFormView: "demo_form_view",
  demoFormSubmit: "demo_form_submit",
  registerStart: "register_start",
  languageSwitch: "language_switch",
} as const;
